import React, { Component } from "react";
import axios from "axios";
import HostStreaming from "../../streaming/HostStreaming";
import RTM from "../../streaming/RTM";
import Language from '../../services/contentData';
import $ from 'jquery';
import { updatesse } from '../../utils/updatesse';
import moment from 'moment';
import playerFunctions from "../../utils/playerFunctions";
import { showMainErrorPop } from '../../actions/popups';
import { connect } from "react-redux";
import InstructorD2C from "./InstructorD2C";
import InstructorEnterprise from "./InstructorEnterprise";
import secondaryWindow from "../../utils/secondaryWindow";

class HostScreen extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			sessionData: {},
			supportPageName: 'Host',
			supportPageApi: '/host',
			userTypeFaqs: JSON.parse(localStorage.getItem('userData')).userType,
			chatOpen: false,
			rightMenuOpen: false,
			activityListOpen: false,
			openLeave: false,
			currentUserData: JSON.parse(localStorage.getItem('userData')),
			sessionStartedByHost: false,
			videoURL: '',
			openActivityVideo: false,
			ejectUserInfo: [],
			reasonEject: '',
			errorReason: false,
			usersOnScreen: 0,
			audienceRaisedList: [],
			signedUpUsers: 0,
			isTutorial: false,
			tutorialStartPop: false,
			tutorialMessagesStatus: false,
			tutorialMessNum: undefined,
			practiceStartPop: false,
			tutorialFinishPop: false,
			oneActWidth: 0,
			InjectedVideoStarted: false,
			// Multi_window related state
			Notes_CurrentActivity: {id: 'activity_1', payload: '', type: 'note'},// format will be used across all notes
			Notes_Callouts: [],
			Notes_Alerts: [],
			multi_window: false,
			canStartSessionRTM: false,
			autoShowedMessage: false,
			cameraArray: [],
			micArray: [],
			spArray: [],
			sep: '~@$',
			// @end Multi_window related state
		}
		
		RTM.getInstance().registerHandler(this.RTMCallback.bind(this));
		window['updateStateHostScreen'] = this.updateStateHostScreen;
		window['updateRaisedHandList'] = this.updateRaisedHandList;
		window['removeUserFromAudienceList'] = this.removeUserFromAudienceList;
		window['addUserToAudienceList'] = this.addUserToAudienceList;
		window['clearAudienceRaisedList'] = this.clearAudienceRaisedList;
		this.updatesse = updatesse.bind(this);
		this.playerFunctions = new playerFunctions();
		this.secondaryWindowCall = new secondaryWindow();
		window['playerFunctions'] = this.playerFunctions;
		window['nowCanStartSession'] = this.nowCanStartSession;
		window['updateDeviceArray'] = this.updateDeviceArray;
		window['updateChoosenStatus'] = this.updateChoosenStatus;
		window['sendSyncToRemote'] = this.sendSyncToRemote;
		window['selectDeviceById'] = this.selectDeviceById;
  }

	componentDidMount() {
		window.addNote = this.addNote;
		window.removeNote = this.removeNote;

		let build_callouts = () => {
			let messages = [];
			let milestone_messages = [];
			let userData = JSON.parse(localStorage.getItem('userData'));
			let birthday = "";
			if (userData.callouts && userData.callouts.birthday) {
				birthday = userData.callouts.birthday;
			}
			const users = JSON.parse(localStorage.getItem('tempUsers'))
			const milestones = JSON.parse(this.state.currentUserData.default.calloutsMilestones);
			users.forEach(user => {
				if (!user.hostStatus && user.isOnline) {
					if (milestones.includes(user.attendedClasses)) {
						if (typeof messages[user.attendedClasses]) {
							messages[user.attendedClasses] = ''
						}
						messages[user.attendedClasses] += messages[user.attendedClasses].length === 0 ? `${user.attendedClasses} Workouts: ${user.firstName}` : `, ${user.firstName}`;
					}

				}
			})

			messages.forEach((message, id) => {
				milestone_messages.push({id: `callout_milestone-${id}`, payload: message, type: 'callout'})
			})
			this.setState({
				Notes_Callouts: [...birthday, ...milestone_messages]
			})
		}
		window.build_callouts = build_callouts;
		
		let tutorialData = JSON.parse(localStorage.getItem('tutorialData'));
		if ( tutorialData ) 
			{
				if ( this.state.currentUserData.sessionData.id == tutorialData.sessionId )
					{
						this.setState({isTutorial: true, tutorialStartPop: true});
					}
				
			}
		var mainData = [];	
		window['turnOffSwitch'] = this.turnOffSwitch;
		if (localStorage.getItem('userData')) {
			mainData = JSON.parse(localStorage.getItem('userData'));
			if (mainData.isMarketplaceChannel === 1 && window['electron'] !== undefined) {
				this.setState({
					sessionData: mainData.sessionData,
					multi_window: true,
				},() =>{ 
					//$('#instructor_settings').addClass('d-none'); 
				});
				build_callouts();
			} else {
				this.setState({sessionData: mainData.sessionData});
			}
		}

		HostStreaming();

		var onScreen = isNaN(parseInt($('#maxuserlimit').find(":selected").text())) ? 0 : parseInt($('#maxuserlimit').find(":selected").text());

		this.setState({usersOnScreen: onScreen});
		this.getChannelInfo(this.state.currentUserData.sessionData.sessionChannelId, this.state.currentUserData.id);
		
		localStorage.setItem("hostSettings", JSON.stringify({
            'sessionId' : this.state.currentUserData.sessionData.id,
            'showOtherParticipants' : this.state.currentUserData.sessionData.showOtherParticipants,
            'switchHostParticipant' : this.state.currentUserData.sessionData.switchHostParticipant,
            'disableNotificationSound' : this.state.currentUserData.sessionData.disableNotificationSound,
            'turnoffRoomSetup' : 1,
			'calculateAssessmentDimensions' : JSON.parse(localStorage.getItem('userData')).sessionData.calculateAssessmentDimensions
        }));
		
		var mainthis = this;
		setTimeout(function(){
			if ( window['checkUnreadMessages'] )
				{
					window['checkUnreadMessages']();
				}
			if ( mainData.isMarketplaceChannel === 1 && window['electron'] )
				{
					mainthis.secondaryWindowCall.openNewWindows();
					if ( window['resubscribeAll'] )
						{
							window['resubscribeAll']();
						}
					if ( window['showD2CmembersOnline'] )
						{
							window['showD2CmembersOnline']();
						}
				}				
		}, 1000);
		
		this.calcForScript();
	}
	
	calcForScript=()=>{
		let script = this.state.currentUserData.sessionData.scriptDetail;
		if ( script.length > 0 )
			{
				let visibleWidth = $('.holdAllActs').width();
				let oneActWidth = 0;
				if ( script.length > 2 )
					{
						oneActWidth = visibleWidth / 3;
					}
				else if ( script.length > 1 )
					{
						oneActWidth = visibleWidth / 2;
					}
				else 
					{
						oneActWidth = visibleWidth;
					}
				this.setState({
					oneActWidth: oneActWidth,
				});
			}
	}
	
	updateStateHostScreen = () =>{
		this.setState({usersOnScreen: parseInt($('#maxuserlimit').find(":selected").text())});
	}
	
	nowCanStartSession = () =>{
		this.setState({
			canStartSessionRTM: true,
			autoShowedMessage: true
		}, ()=> {console.log(this.state.canStartSessionRTM);});
	}
	
	RTMCallback = (payload) => {
		console.log('payload - ', payload, payload.code);
		
		if ( payload.code == 1 )
			{
				this.checkUpcomingSession();
			}

		if ( payload.code == 23 )
			{
				window['checkForFm']();
			}
	}
	
	updateDeviceArray=(mod, mod1, mod2)=>{
		let mainthis = this;
		mainthis.setState({cameraArray: mod, micArray: mod1, spArray: mod2}, ()=>{ console.log('mainthis.state', mainthis.state); }); 
	}
	
	
	updateChoosenStatus=(mod, type)=>{
		
		if ( type == 'camera' )
			{
				var allCameras = this.state.cameraArray;
				for ( var i = 0; i<allCameras.length; i++ ) { allCameras[i]['choosenStatus'] = false; }
				allCameras[mod]['choosenStatus'] = true;
				this.setState({cameraArray: allCameras});
			}
		else if ( type == 'mic' )
			{
				var allMic = this.state.micArray;
				for ( var i = 0; i<allMic.length; i++ ) { allMic[i]['choosenStatus'] = false; }
				allMic[mod]['choosenStatus'] = true;
				this.setState({micArray: allMic});
			}
		else if ( type == 'sp' )
			{
				var allSp = this.state.spArray;
				for ( var i = 0; i<allSp.length; i++ ) { allSp[i]['choosenStatus'] = false; }
				allSp[mod]['choosenStatus'] = true;
				this.setState({spArray: allSp});
			}
	}
	
	selectDeviceById=(deviceId, type)=>{
		if ( type == 'camera' )
			{
				var allCameras = this.state.cameraArray;
				for ( var i = 0; i<allCameras.length; i++ )
					{
						if ( allCameras[i]['deviceId'] == deviceId )
							{
								this.updateChoosenStatus(i, 'camera');	
							}
					}
			}
		else if ( type == 'mic' )
			{
				var allMic = this.state.micArray;
				for ( var i = 0; i<allMic.length; i++ )
					{
						if (allMic[i]['deviceId'] == deviceId )
							{
								this.updateChoosenStatus(i, 'mic');
							}
					}
			}			
	}
	
	sendSyncToRemote=()=>{
		let cameraName = '';
		let cameraId = 0;
		let isSelected = false;
		
		let micName = '';
		let micId = 0;
		let isSelectedMic = false;
		
		let cameraObject = [];
		let camerasArray = this.state.cameraArray;
		for ( var i = 0; i < camerasArray.length; i++ )
			{
				let cameraOption = {};
				cameraOption['name'] = camerasArray[i]['label'];
				cameraOption['id'] = camerasArray[i]['deviceId'];
				cameraOption['isSelected'] = camerasArray[i]['choosenStatus'];
				cameraObject.push(cameraOption);
			}	
		
		let micObject = [];
		let audioId='';
		let audioArray = this.state.micArray;
		for ( var b = 0; b<audioArray.length; b++ )
			{
				let micOption = {};
				micOption['name']=audioArray[b]['label'];
				micOption['id']=audioArray[b]['deviceId'];
				micOption['isSelected']=audioArray[b]['choosenStatus'];
				micObject.push(micOption);
			}
		let activityDuration = 0;
		var sessionData = JSON.parse(localStorage.getItem('userData')).sessionData;
		var startRecording = false;
		var startMusic = false;
		
		if ( sessionData.StartRecordSession === 1 )
			{
				startRecording = true;
			}
			
		if ( sessionData.StartMusicSession === 1 )
			{
				startMusic = true;
			}
		
		let settinsObject = {};
		settinsObject['startRecordingAtStartScript'] = startRecording;
		settinsObject['startMusicAtStartScript'] = startMusic;
		
		let scriptObject = {};
		let scriptPlaying = 0;
		if ( sessionData && sessionData.sessionActivity && sessionData.sessionActivity.length > 0 )
			{
				let indexNum = 0;
				if ( window['currentActNum'] )
					{
						indexNum = window['currentActNum'] - 1;
					}
					
				if ( sessionData.sessionActivity[indexNum] )
					{
						activityDuration = sessionData.sessionActivity[indexNum]['Count'];
					}
					
				if ( window['timeLefSec'] )
					{
						activityDuration = window['timeLefSec'];
					}					
					
				if ( window['activityStarted'] )
					{
						scriptPlaying = 1;
					}					
				
				scriptObject['currentScriptId'] = indexNum;
				scriptObject['scriptPlaying'] = scriptPlaying;
				scriptObject['durationRemaining'] = activityDuration;
			}
			
		let mainObject = {};
		mainObject['classStarted'] = this.state.sessionStartedByHost;
		mainObject['script'] = scriptObject;
		mainObject['cameraList'] = cameraObject;
		mainObject['audioList'] = micObject;
		mainObject['settings'] = settinsObject;
		mainObject = JSON.stringify(mainObject);
		
		let msg = 'remoteSync'+this.state.sep+mainObject;
		
		if ( window['globalRTM'] )
			{
				window['globalRTM'](`RM-${sessionData.hostEmail}`,msg);
			}
	}
	
	stopPlayer=()=>{
		this.playerFunctions.stopPlayer();
		window['sendMessageToChannel']("feedFm"+this.state.sep+"stop");
		window['showVolume'](false);
	}
	
	checkUpcomingSession = () => {
  		this.stopPlayer();
		
		$('.main_loader').attr({'style':'display:flex'});
		const userData = {
            userId: this.state.currentUserData.id,
            auth: this.state.currentUserData.token
        };
		
		if ( localStorage.getItem('currentUser') && localStorage.getItem('currentUserToken') )
			{
				userData['userId'] = localStorage.getItem('currentUser');
				userData['auth'] = localStorage.getItem('currentUserToken');
				localStorage.removeItem('currentUser');
				localStorage.removeItem('currentUserToken');
			}
		
		axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/loginNative", userData).then(res => {
            res.data.responseData.unmuteAllEnabled = false;
            localStorage.setItem("userData", JSON.stringify(res.data.responseData));
            this._handleUpcomingSessions();
          }).catch(err => {
              //this._handleCloseWindow();
			  this._handleUpcomingSessions();
          });
	}
	
	_handleUpcomingSessions = () => {
		this.props.history.push('home');
	}
	
	_handleCloseWindow = () => {
      localStorage.removeItem("userData");

      if (window['electron'])
      {
          window.forceCloseWindow();
      }
      else
      {
          window.onbeforeunload = null;
          window.close();
          window.location.href = '/login';
      }
	}
	
	updateStateFromChild=(state)=>{
		this.setState(state);
	}
	
	startSession=()=>{
		this.setState({
			sessionStartedByHost: true,
		});
		
		window.hostStartSession();
		$("#mute_control").removeClass('d-none');
		
		$("#record_session").removeClass('d-none');		
		
		var script = JSON.parse(localStorage.getItem('userData')).sessionData.scriptDetail;
		if ( script && script.length > 0 )
			{
				$('#playlist_content').addClass('playlist_footer_activity');
			}
		let mainthis = this;
		setTimeout(function(){
			mainthis.calcForScript();
		}, 100);
		
		this.updatesse('updateHostStartedSession', [this.state.currentUserData.id, this.state.currentUserData.sessionData.id, 1]);
		
		setTimeout( function(){
			if ( window['eventCurrent'] && window['eventCurrent']['updateHostStartedSession'] )
				{
					window['eventCurrent']['updateHostStartedSession'].close();
					window['eventCurrent']['updateHostStartedSession'] = false;
				}
		}, 1000);
	}
	
	setOnScreen=(e)=>{
		let tempData = this.state.usersOnScreen;
		let value = parseInt(e.target.value);
		let checkStatus = true;
		if ( window['checkIfSetLimitCanChange'] )
			{
				checkStatus = window['checkIfSetLimitCanChange'](value);	
			}
			
		if ( checkStatus )
			{
				var onScreenUsersInfo = parseInt(value);
				this.state.currentUserData.default.maxUserLimit = onScreenUsersInfo;
				//localStorage.setItem('userData', JSON.stringify(this.state.currentUserData));
				window.setUserLimit(onScreenUsersInfo);
				this.setState({usersOnScreen: onScreenUsersInfo});
				window.makeNewDisplayStreams(value);
			}
		else
			{
				if ( window['setNewDropdown'] )
					{
						window['setNewDropdown']();
					}
				return false;
			}			
				
				
	}
	
	showParticipantList=(mod)=>{
		if ( mod == 1 )
			{
				window.displayParticipants(true);
			}			
		else 
			{
				$('#memebrsList').addClass('d-none');
			}			
	}
	
	ejectParticipant=(mod)=>{
		this.setState({
			ejectUserInfo: mod,
		}, ()=>{$('.participantEjectPop').removeClass('d-none');});
	}
	
	closeEjectPop=()=>{
		this.setState({
			ejectUserInfo: [],
			reasonEject: '',
			errorReason: false,
		}, ()=>{$('.participantEjectPop').addClass('d-none');});
	}
	
	ejectCurrentParticipant=()=>{
		
		if ( this.state.reasonEject === '' ) 
			{
				this.setState({errorReason: true});
				return false;
			}
		
		var postData = { sessionId:this.state.currentUserData.sessionData.id, userId: this.state.ejectUserInfo.id, channelId: this.state.currentUserData.sessionData.sessionChannelId, reason: this.state.reasonEject};
			
		$('.main_loader').attr({'style':'display:flex'});
		axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/ejectParticipantFromSession", postData).then(res => {
			window.removeCurrentParticipant(this.state.ejectUserInfo.id, this.state.ejectUserInfo.email);
			this.setState({
				ejectUserInfo: [], reasonEject: '', errorReason: false
				}, () => {
						$('.participantEjectPop').addClass('d-none')
					});
			
			var userData = JSON.parse(localStorage.getItem("userData"));
			let config = { headers: { "Authorization": userData.token } };	
			axios.get(process.env.REACT_APP_API_URL+"/api/v1/session/"+userData.sessionData.id+"/users", config)
				.then(res => {
					localStorage.setItem("tempUsers", JSON.stringify(res.data.responseData));
					window.displayParticipants();
				}).catch(err => {}
			);
			$('.main_loader').hide();
		}).catch(err =>{ $('.main_loader').hide(); }); 		
	}
	
	playActivityVideo=(url)=>{
		if ( !this.state.openActivityVideo )
			{
				this.setState({videoURL: url, openActivityVideo: true});
			}
		else
			{
				this.setState({openActivityVideo: false}, () => {this.setState({videoURL: url, openActivityVideo: true})});
			}
	}
	
	callfunction = e => {
		//localStorage.removeItem("media-setting");
		localStorage.removeItem("tempUsers");
		localStorage.removeItem("video-resolution");
		window.$('.main_loader').attr({'style':'display:flex'});
		window.$('#multi-device-login-alert').modal('hide');
		this.checkUpcomingSession();
	}
	
	getChannelInfo = (channelId, userId) => {
		if ( channelId && userId )
			{
				axios.post(process.env.REACT_APP_API_URL+"/api/v1/channel/insertChannelSettings", { 'channel_id': channelId, 'user_id': userId }).then(res => {
					
					let userAllData = JSON.parse(localStorage.getItem('userData'));
					userAllData['isMarketplaceChannel'] = res.data.responseData.isMarketplaceChannel;
					localStorage.setItem("userData", JSON.stringify(userAllData));
					
					this.setState({
						isMarketplaceChannel: res.data.responseData.isMarketplaceChannel,
						currentUserData: userAllData,
					}); 
					
					var channelSettingsData = res.data.responseData;
					var enabledFms = channelSettingsData.enabledFms;
					window['enabledFms'] = enabledFms;
				}).catch(err =>{ console.log('err'); }); 
			}
	}
	
	turnOffSwitch = () => {
		let currentHostSettings = JSON.parse(localStorage.getItem("hostSettings"));
		if ( currentHostSettings['switchHostParticipant'] && currentHostSettings['switchHostParticipant'] == 1 )
			{
				var sep = '~@$';
				window['sendMessageToChannel']('waitBeforeDraw'+sep);
				this.saveSettings('off');
			}
	}
	
	updateRaisedHandList = (mod) =>{
		let currentArray = [];
		let currentTimeStamp = new Date().getTime();
		currentTimeStamp = currentTimeStamp + 2;
		mod.forEach((handraise)=>{
			let audienceDetails = {};
			audienceDetails['id'] = handraise.id;
			audienceDetails['firstName'] = handraise.firstName;
			audienceDetails['lastName'] = handraise.lastName;
			audienceDetails['image'] = handraise.image;
			audienceDetails['raisedHandTime'] = handraise.raisedHandTime;
			let timeDur = currentTimeStamp - handraise.raisedHandTime;
			let sec = Math.floor(timeDur / 1000);
			if ( sec < 1 )
				{
					sec = 1;
				}				
			audienceDetails['timeInSec'] = sec;
			let raisedTime = moment(new Date(handraise.raisedHandTime)).format('MM/DD/YY hh:mm a');
			audienceDetails['raisedTime'] = raisedTime;
			currentArray.push(audienceDetails);
		});
		this.setState({audienceRaisedList: currentArray});
	}
	
	closeRaisedList=(ev)=>{
		ev.preventDefault();
		ev.stopPropagation();
		$('.audienceHolder').addClass('d-none');
	}
	
	showRaisedList=()=>{
		$('.audienceHolder').removeClass('d-none');
	}
	
	removeUserFromAudienceList=(mod, setActive)=>{
		let raisedHandUsers = this.state.audienceRaisedList;
		if ( raisedHandUsers.length > 0 )
			{
				for ( var i = 0; i<raisedHandUsers.length; i++ )
					{
						if ( raisedHandUsers[i]['id'] == mod )
							{
								if ( !setActive )
									{
										$('#raiseHandPart'+mod).removeClass('d-none');
									}
								
								raisedHandUsers.splice(i,1);
							}
					}
			}
		if ( raisedHandUsers.length < 1 )
			{
				$('.audienceRaiseHand').addClass('d-none');
				$('.audienceHolder').addClass('d-none');
			}
		this.setState({
			audienceRaisedList: raisedHandUsers
		});		
	}
	
	addUserToAudienceList=(mod)=>{
		let currentTimeStamp = new Date().getTime();
		currentTimeStamp = currentTimeStamp + 2;
		let audienceDetails = {};
		audienceDetails['id'] = mod.id;
		audienceDetails['firstName'] = mod.firstName;
		audienceDetails['lastName'] = mod.lastName;
		audienceDetails['image'] = mod.image;
		audienceDetails['raisedHandTime'] = mod.raisedHandTime;
		let timeDur = currentTimeStamp - mod.raisedHandTime;
		let sec = Math.floor(timeDur / 1000);
		if ( sec < 1 )
			{
				sec = 1;
			}				
		audienceDetails['timeInSec'] = sec;
		let raisedTime = moment(new Date(mod.raisedHandTime)).format('MM/DD/YY hh:mm a');
		audienceDetails['raisedTime'] = raisedTime;
		let raisedHandUsers = this.state.audienceRaisedList;
		if ( raisedHandUsers.length > 0 )
			{				
				if ( raisedHandUsers.indexOf(audienceDetails) == -1 )
					{
						raisedHandUsers.push(audienceDetails);
					}		
			}
		else 
			{
				raisedHandUsers.push(audienceDetails);
				$('.audienceRaiseHand').removeClass('d-none');
			}
		this.setState({
			audienceRaisedList: raisedHandUsers,
		});
			
	}
	
	clearAudienceRaisedList=()=>{
		$('.audienceRaiseHand').addClass('d-none');
		$('.audienceHolder').addClass('d-none');
		this.setState({
			audienceRaisedList: []
		});
	}
	
	hideNoPlanPop=()=>{
		$('#noPlanPop').addClass('d-none');
	}
	
	hideMediaPop=()=>{
		$('#mediaPop').addClass('d-none');
	}
	
	hideSelectedPop=()=>{
		$('#selectedMemberPop').addClass('d-none');
	}

	closePalette=()=>{
		$('.paletteHolder').addClass("d-none");
		$('.host_header').removeClass("d-none");
		$('.participant_view_container').removeClass("d-none");
		$('.paletteFlex').addClass("d-none"); 
	}
	
	startPractice=()=>{
		localStorage.setItem('displayTextNum', 7);
		this.setState({
			practiceStartPop: false,
			tutorialMessNum: 7,
		}, ()=>{
			$('.participants_stream_container').addClass('host_streams1');
		});
	}
	
	startTutorial=()=>{
		var sessionID = this.state.currentUserData.sessionData.id;
		var tutorialStart = this.state.currentUserData.sessionData.isTutorialStart;
		if(tutorialStart==1)
			{
				axios.put(process.env.REACT_APP_API_URL+"/api/v1/session/host/updateDefaultSessionIstutorialStart",{"sessionId":sessionID}).then(res => {
					console.log("here--");
				}).catch(err =>{
					console.log('----------there is problem------------',err);
				});
			}
			
		localStorage.setItem('displayTextNum', 1);
		this.setState({
			tutorialStartPop: false,
			tutorialMessagesStatus: true,
			tutorialMessNum: 1,
		}, ()=>{
			window['tutorialMessNum'] = this.state.tutorialMessNum;
			$("#mute_control").removeClass('d-none');
			$("#record_session").removeClass('d-none');	
		});
	}
	
	nextTutorial=(mod, ev?)=>{
		let newNum = parseInt(mod) + 1;
		localStorage.setItem('displayTextNum', newNum);	
		this.setState({
			tutorialMessNum: newNum,
		}, () =>{
			window['tutorialMessNum'] = this.state.tutorialMessNum;
			if ( newNum == 2 )
				{
					$('.audienceRaiseHand').removeClass('d-none');
					$("#mute_control").addClass('d-none');
					$("#record_session").addClass('d-none');
				}
			if ( newNum != 2 )
				{
					$('.audienceRaiseHand').addClass('d-none');
				}
			if ( newNum == 7 ) 
				{
					this.setState({
						practiceStartPop: true,
					})
				}				
		});
	}
	
	backTutorial=(mod, ev?)=>{
		let newNum = parseInt(mod) - 1;
		localStorage.setItem('displayTextNum', newNum);	
		if ( newNum == 0 )
			{
				this.setState({tutorialStartPop: true});
			}
		this.setState({
			tutorialMessNum: newNum,
		}, () =>{
			window['tutorialMessNum'] = this.state.tutorialMessNum;
			if ( newNum == 2 )
				{
					$('.audienceRaiseHand').removeClass('d-none');
					$("#mute_control").addClass('d-none');
					$("#record_session").addClass('d-none');
				}
			if ( newNum != 2 )
				{
					$('.audienceRaiseHand').addClass('d-none');
				}	
		});
}

finishTutorial = (mod) => {
	this.setState({
		tutorialFinishPop: true,
	}, () => {
	});
}

updateTutorial = () => {
	localStorage.setItem('readTutorial', true);
	localStorage.removeItem('tutorialData');

	var sessionID = this.state.currentUserData.sessionData.id;
	var tutorialId = this.state.currentUserData.sessionData.isTutorialRead;
	if (tutorialId == 1) {
		axios.put(process.env.REACT_APP_API_URL + "/api/v1/session/host/updateDefaultSession", {
			"sessionId": sessionID
		})
			.then(res => {
				this.setState({
					isTutorial: false,
					tutorialStartPop: false,
					tutorialMessagesStatus: false,
					tutorialMessNum: undefined,
					tutorialFinishPop: false,
				})
			}).catch(err => {
			console.log('----------there is problem------------', err);
		});
	}

}

addNote = (note) => { // {id: '$type_$1', payload: '', type: 'note'}
	if (note.type === 'alert') {
		this.setState({Notes_Alerts: this.state.Notes_Alerts.length > 0 ? [note].concat(this.state.Notes_Alerts) : [note]})
	} else {
		this.setState({Notes_Callouts: this.state.Notes_Callouts.length > 0 ? [note].concat(this.state.Notes_Callouts) : [note]})
	}
}
removeNote = (noteId) => {
	const type = noteId.split("_")[0];
	if (type === 'alert') {
		this.setState({
			Notes_Alerts: this.state.Notes_Alerts.length > 0 ? this.state.Notes_Alerts.filter(note => {
				return note.id !== noteId
			}) : []
		})
	} else if (type === 'callout') {
		this.setState({
			Notes_Callouts: this.state.Notes_Callouts.length > 0 ? this.state.Notes_Callouts.filter(note => {
				return note.id !== noteId
			}) : []
		})
	} else if (type === 'activity') {
		this.setState({Notes_CurrentActivity: {id: 'activity_1', payload: '', type: 'note'},})
	}
}

startSessionInfo = (mod) =>{
	if ( this.state.autoShowedMessage && mod && mod == 'update' )
		{
			return false;
		}
	this.props.showMainErrorPop("You have a poor internet connection and you cannot start the Class.");
	this.setState({autoShowedMessage: true});
}

startSessionD2C=()=>{
	if ( this.state.canStartSessionRTM )
		{
			this.startSession();
		}
	else 
		{
			this.startSessionInfo();
		}		
	
};

render()
{
	let {multi_window} = this.state;

	return (
		<div>
			{ this.state.multi_window ? 
				<div id="multi_window"> 
					<div className={"hostScreenMainDiv " + (this.state.rightMenuOpen ? "move_support_right" : "")}>
						<InstructorD2C 
						mainthis={this}
						cameraArray={this.state.cameraArray}
						micArray={this.state.micArray}
						spArray={this.state.spArray}
						></InstructorD2C>
					</div>
				</div>
				:
				<div className={"hostScreenMainDiv " + ( this.state.rightMenuOpen ? "move_support_right" : "" ) } >
					<InstructorEnterprise mainthis={this}></InstructorEnterprise>
				</div>
			}
		

			<div id="session-saving-recording" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog modal-confirm modal-dialog-centered">
					<div className="modal-content bg-grayy px-4 position-relative radius-10">
						<div className="modal-header justify-content-center px-0 border-bottm">
							<h5 className="modal-title white_hdng">{Language.recordingPopUp.heading}</h5>
						</div>
						<div className="modal-body">
							<div>
								<p className="text-white font-20 mb-4">{Language.recordingPopUp.bodyMsg}</p>
								<div className="newprogressbar"><div></div></div>
								<div className="text-white newprogressbarinfo"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div id="finished-upload-failed" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
			  <div className="modal-dialog modal-confirm modal-dialog-centered">
				<div className="modal-content bg-grayy px-4 position-relative radius-10">
				  <div className="modal-body">
					<div>
					  <p className="text-white font-20 mb-4 recording_alert_hold">Recording not uploaded.</p>
					</div>
				  </div>
				</div>
			  </div>
			</div>
			
			<div id="finished-upload" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
			  <div className="modal-dialog modal-confirm modal-dialog-centered">
				<div className="modal-content bg-grayy px-4 position-relative radius-10">
				  <div className="modal-body">
					<div>
					  <p className="text-white font-20 mb-4 recording_alert_hold">Recording uploaded successfully.</p>
					</div>
				  </div>
				</div>
			  </div>
			</div>
			
			<div className="stream_pop_holder d-none" id="noPlanPop">
				<div className="stream_inner_pop noPlanColor">
					<div className="stream_pop_text">No On Demand Plan enabled</div>
					<div className="no_plan_h2" >No On-Demand Plan enabled. In order to Record your Class and share it with your clients you must have an On-Demand Plan selected for your Channel Subscription.</div>
					<div className="stream_btns_holder">
						<div className="hold_btn1" >
							<div className="stream_cancel_btn" onClick={this.hideNoPlanPop}>OK</div>
						</div>
					</div>
				</div>					
			</div>
			
			<div className="stream_pop_holder d-none" id="mediaPop">
				<div className="stream_inner_pop noPlanColor">
					<div className="stream_pop_text">Media Access Error</div>
					<div className="no_plan_h2" >Virdio is unable to access your camera or microphone even though access was granted. Please check if it’s being used by another app or restart your device.</div>
					<div className="stream_btns_holder">
						<div className="hold_btn1" >
							<div className="stream_cancel_btn" onClick={this.hideMediaPop}>OK</div>
						</div>
					</div>
				</div>					
			</div>
			
			<div className="stream_pop_holder d-none" id="selectedMemberPop">
				<div className="stream_inner_pop noPlanColor">
					<div className="stream_pop_text">Number of members On Screen error</div>
					<div className="no_plan_h2" >Number of members On Screen cannot be lower than the number of pinned members</div>
					<div className="stream_btns_holder">
						<div className="hold_btn1" >
							<div className="stream_cancel_btn" onClick={this.hideSelectedPop}>OK</div>
						</div>
					</div>
				</div>					
			</div>
			
			<div className="participantEjectPop d-none">
				<div className="eject_pop_holder" >
					<div className="partMain" >
						<div className="circleImgHolder" >
							{this.state.ejectUserInfo.image ? 
								<div className="ejectedUserProfile" style={{backgroundImage: "url('" + this.state.ejectUserInfo.image + "')"}} ></div>
								:
								<div className="ejectedUserProfile memberDefImg"></div>
							}
						</div>
						<div className="eject_h1" >Are you sure you want to remove {this.state.ejectUserInfo.firstName} {this.state.ejectUserInfo.lastName} from class?</div>
						<div className="for_area_eject">
							<textarea className={"text_area_pop new_popup_color " + (this.state.errorReason ? 'error_reason' : '')} maxLength="300" value={this.state.reasonEject} id="reasonEject" placeholder="Reason to eject..." onChange={(e)=>this.setState({[e.target.id]:e.target.value, errorReason: false})}></textarea>
						</div>
						<div className="buttons_holder_eject" >
							<div className="eject_btns" onClick={this.closeEjectPop} >CANCEL</div>
							<div className="eject_btns margin_eject_btn" onClick={this.ejectCurrentParticipant}>EJECT</div>
						</div>
					</div>
				</div>
			</div>
			
			<div id="multi-device-login-alert" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog modal-confirm modal-dialog-centered">
				  <div className="modal-content bg-grayy px-4 position-relative radius-10">
					<div className="modal-header justify-content-center px-0 border-bottm">
					  <h5 className="modal-title white_hdng">{Language.multipleDevice.heading}</h5>
					</div>
					<div className="modal-body">
					  <div>
						<p className="text-white font-17 mb-5">{Language.multipleDevice.msg}</p>
					  </div>
					</div>
					<div className="ok_btn_cont w-100 text-center">
					  <button className="ok-btn" onClick={this.callfunction.bind(this)}>{Language.multipleDevice.btn}</button>
					</div>
				  </div>
				</div>
			</div>
			
			<div id="canvasNotePopup" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false" style={{ display: "none", opacity: "0" }}>
				<div className="modal-content bg-grayy px-4 radius-10 mw-70 note-modal">
					<div className="modal-header px-0 border-bottm">
						<h5 className="modal-title note-modal-title">Write Note</h5>
					</div>
					<div className="modal-body d-flex">
						<div className="note-img2">
							<img id="screenshotPreviewImg" />
						</div>
						<div className="note-right-side">
							<div className="note-textarea-hold">
								<textarea className="canvas-note-textarea"></textarea>
								<span className="cover-border"><div className="note-description">Description</div></span>
							</div>
							<div className="buttons-holder">
								<button className="cancel-btn" id="closeNotePop"><a href="javascript:void(0)" className="text-white">CANCEL</a></button>
								<button className="ok-btn" id="saveCanvasNote">SAVE</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			  
			<div id="viewNotePopup" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog modal-confirm modal-dialog-centered" style={{ maxHeight: "60%", maxWidth: "60%", transform: "none" }}>
					<div className="modal-content bg-grayy px-4 position-relative radius-10 note-view-holder scroll_notes">
						<button type="button" className="close close-note-view" data-dismiss="modal"><span>×</span></button>
						<div className="modal-header px-0 border-bottm">
							<h5 className="modal-title note-modal-title">Note</h5>
						</div>
						<div className="modal-body">
							<div className="" >
								<div id="viewNoteText" className="note-view-text"></div>
								<img id="viewNoteImg" className="imageHolderNote" />
								<div id="viewNoteDate" className="note-view-text padTop5"></div>
							</div>
							<div className="buttons-holder">
								<button className="cancel-btn" id="deleteNote"><a href="javascript:void(0)" className="text-white">DELETE</a></button>
								<button className="ok-btn" id="closeNoteView">OK</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			  
			<div className="main_loader">
				<div className="main_loader_inner"></div>
			</div>
			
			<div className="bigCountShow d-none" id="partBigCounter">
				<div className="countNumD2C" id="partCounterNum">0</div>
			</div>
			
			{ this.state.tutorialStartPop && 
				<div className="stream_pop_holder" id="tutorialStarted">
					<div className="stream_inner_pop noPlanColor">
						<div className="stream_pop_text">Congratulations {this.state.sessionData.hostFirstName}, you made it to your tutorial!</div>
						<div className="no_plan_h2" >
							<div>Now the fun begins...</div>
							<div>Time to make you an expert with the buttons on this screen.</div>	
							<div>You can use your left or right arrow keys on your remote to go back one step or move forward.</div>	
							<div>Ready? Press the "Start Tutorial" button below or "Ok" on your remote.</div>	
						</div>
						<div className="stream_btns_holder">
							<div className="hold_btn1" >
								<div className="stream_cancel_btn" onClick={this.startTutorial}>Start Tutorial</div>
							</div>
						</div>
					</div>					
				</div>
			}
			
			{ this.state.practiceStartPop && 
				<div className="stream_pop_holder" id="practiceStarted">
					<div className="stream_inner_pop noPlanColor">
						<div className="stream_pop_text">Good job! Now let's try a guided practice.</div>
						<div className="no_plan_h2" >
							<div>By pressing OK, you will be getting step by step instructions to try out few important features.</div>	
						</div>
						<div className="stream_btns_holder">
							<div className="hold_btn1" >
								<div className="stream_cancel_btn" onClick={this.startPractice}>Ok</div>
							</div>
						</div>
					</div>					
				</div>
			}
			
			{ this.state.tutorialFinishPop && 
				<div className="stream_pop_holder" id="practiceStarted">
					<div className="stream_inner_pop noPlanColor">
						<div className="stream_pop_text">Well done!</div>
						<div className="no_plan_h2" >
							<div>You practiced the basic features.</div>	
							<div>Let's start your class now.</div>	
						</div>
						<div className="stream_btns_holder">
							<div className="hold_btn1" >
								<div className="stream_cancel_btn" onClick={this.updateTutorial}>Ok</div>
							</div>
						</div>
					</div>					
				</div>
			}

			<div style={{width: "1px", height: "1px", position: 'absolute', backgroundColor: 'black', overflow: 'hidden'}}>
				<canvas id="video_precanvas" width="1280" height="720"></canvas>
			</div>	
		  
			<div style={{width: "1px", height: "1px", position: 'absolute', backgroundColor: 'black', overflow: 'hidden'}}>
				<canvas id="video_precanvas" width="1280" height="720"></canvas>
			</div>
		</div>
	)}
}
export default connect(
  null,
  { 
	showMainErrorPop
  }
)(HostScreen);